export default __webpack_public_path__ + "static/media/Buildingrip4.8c3a4f12.svg";